import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const ServicePackageForm = lazy(
  () => import('@app/features/servicePackages/components/ServicePackageForm/ServicePackageForm')
);
const EditServicePackage = lazy(() =>
  import('@pages/servicePackages/EditServicePackagePage').then((m) => ({ default: m.EditServicePackage }))
);
const ServicePackagesListPage = lazy(() => import('@pages/servicePackages/ServicePackagesPage'));

const ServicePackageTablePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('service-packages-page-title')}>
        <ServicePackagesListPage />
      </PageWrapper>
    </Suspense>
  );
};

const ServicePackageFormPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('service-packages-create-page-title')}>
        <ServicePackageForm />
      </PageWrapper>
    </Suspense>
  );
};

const ServicePackageEditPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('service-packages-edit-page-title')}>
        <EditServicePackage />
      </PageWrapper>
    </Suspense>
  );
};

export default {
  ServicePackageFormPage,
  ServicePackageTablePage,
  ServicePackageEditPage,
};
